import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { LayoutDashboard, FileText, Award, LogOut, Building2, Copy } from 'lucide-react';
import Footer from '../common/Footer';
import '../common/Footer.css';
import './Layout.css';

export default function Layout() {
  const { institution, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const copyLink = () => {
    navigator.clipboard.writeText(`${window.location.origin}/form/${institution?.slug}`);
    alert('הקישור הועתק!');
  };

  return (
    <div className="layout">
      <aside className="sidebar">
        <div className="sidebar-header">
          <div className="sidebar-logo">
            <Award size={24} />
            <span>אישורי לימודים</span>
          </div>
          <div className="sidebar-inst">{institution?.name}</div>
        </div>

        <nav className="sidebar-nav">
          <NavLink to="/dashboard" className={({isActive}) => isActive ? 'nav-item active' : 'nav-item'}>
            <LayoutDashboard size={18} />
            <span>דשבורד</span>
          </NavLink>
          <NavLink to="/templates" className={({isActive}) => isActive ? 'nav-item active' : 'nav-item'}>
            <FileText size={18} />
            <span>תבניות</span>
          </NavLink>
          <NavLink to="/certificates" className={({isActive}) => isActive ? 'nav-item active' : 'nav-item'}>
            <Award size={18} />
            <span>אישורים</span>
          </NavLink>
        </nav>

        <div className="sidebar-footer">
          <button className="nav-item copy-link" onClick={copyLink}>
            <Copy size={18} />
            <span>קישור לטופס</span>
          </button>
          <button className="nav-item logout" onClick={handleLogout}>
            <LogOut size={18} />
            <span>התנתקות</span>
          </button>
        </div>
      </aside>

      <main className="main-content">
        <Outlet />
        <Footer />
      </main>
    </div>
  );
}
